import { API_RESULT_TYPE } from '@/models/entities/api/api-result-type';

export default class ApiAlreadyHandled {
  apiResultType: typeof API_RESULT_TYPE.ALREADY_HANDLED;

  constructor() {
    this.apiResultType = API_RESULT_TYPE.ALREADY_HANDLED;
  }
}
